import { render } from "./RecentSales.vue?vue&type=template&id=40ae6500&scoped=true"
import script from "./RecentSales.vue?vue&type=script&lang=js"
export * from "./RecentSales.vue?vue&type=script&lang=js"

import "./RecentSales.vue?vue&type=style&index=0&id=40ae6500&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ae6500"]])

export default __exports__